import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { FarmersApplicationService } from 'src/app/services/farmers-application.service';
import { IpAddressService } from 'src/app/services/ip-address.service';
import saveAs from 'file-saver';
import { CryptoJsService } from 'src/app/services/crypto-js.service';

@Component({
  selector: 'app-krishi-mapper',
  templateUrl: './krishi-mapper.component.html',
  styleUrls: ['./krishi-mapper.component.scss']
})
export class KrishiMapperComponent implements OnInit {
  public appVerificationItems: MenuItem[];

  public userId: any;
  public ipAddress: any;

  public dataToShow: any = [];
  public columns: any = [];

  public typeList: any = [];
  public selectedType: any;
  public yearList: any = [];
  public selectedYear: any;
  public monthList: any = [];
  public selectedMonth: any;

  public showDataTable: boolean = false;
  public freezeDataDropdown: boolean = false;

  constructor(
    private loader: AppLoaderService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private ipService: IpAddressService,
    private fApplicationService: FarmersApplicationService,
    private cryptoJsService: CryptoJsService
  ) { }

  ngOnInit(): void {
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;

    this.appVerificationItems = [
      {
        label: 'Download excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcel(this.dataToShow, `${this.selectedType.value}-${this.selectedYear.value}-${this.selectedMonth.value}`);
        },
      },
      // {
      //   label: 'Download Pdf',
      //   icon: 'pi pi-fw pi-download',
      //   command: () => {
      //     this.downloadSheetAsPdf(
      //       this.appVerificationModel,
      //       'App_Verification_List'
      //     );
      //   },
      // },
    ];

    this.getIP();
    this.getTypeList();
    this.getYearList();
    this.getMonthList();
  }

  getIP() {
    if (sessionStorage.getItem('ipAddress')) {
      this.ipAddress = JSON.parse(window.sessionStorage.getItem('ipAddress'));
    } else {
      this.ipService.getIPAddress().subscribe((res: any) => {
        this.ipAddress = res.ip;
        sessionStorage.setItem('ipAddress', JSON.stringify(this.ipAddress));
      });
    }
  }

  getTypeList() {
    // this.loader.start();
    // this.fApplicationService
    //   .getOutletByContractor()
    //   .pipe(first())
    //   .subscribe({
    //     next: (res) => {
    //       this.loader.close();
    //       this.typeList = res;
    //     },
    //     error: (err) => {
    //       this.loader.close();
    //       this.typeList = [];
    //       this.messageService.add({
    //         severity: 'error',
    //         summary: 'Error Message',
    //         detail: err,
    //       });
    //     },
    //   });

    setTimeout(() => {
      this.typeList = [
        {
          code: 1,
          value: 'Beneficiary Activity',
        },
        {
          code: 2,
          value: 'Beneficiary Transaction Details',
        },
        {
          code: 3,
          value: 'Beneficiary Crops',
        },
        {
          code: 4,
          value: 'Beneficiary Geo Fence Data',
        },
        {
          code: 5,
          value: 'Beneficiary GPS Master Data',
        },
      ];
    }, 100);
  }

  getYearList() {
    setTimeout(() => {
      this.yearList = [
        {
          code: 1008,
          value: '2022-23',
        },
        {
          code: 1009,
          value: '2023-24',
        },
        {
          code: 1010,
          value: '2024-25',
        },
        {
          code: 1011,
          value: '2025-26',
        }
      ];
    }, 100);
  }

  getMonthList() {
    setTimeout(() => {
      this.monthList = [
        {
          code: 1,
          value: 'January',
        },
        {
          code: 2,
          value: 'February',
        },
        {
          code: 3,
          value: 'March',
        },
        {
          code: 4,
          value: 'April',
        },
        {
          code: 5,
          value: 'May',
        },
        {
          code: 6,
          value: 'June',
        },
        {
          code: 7,
          value: 'July',
        },
        {
          code: 8,
          value: 'August',
        },
        {
          code: 9,
          value: 'September',
        },
        {
          code: 10,
          value: 'October',
        },
        {
          code: 11,
          value: 'November',
        },
        {
          code: 12,
          value: 'December',
        }
      ];
    }, 100);
  }

  refreshTable() {
    this.onClickGetData();
  }

  onClickGetData() {
    // console.log(this.selectedType)
    // console.log(this.selectedMonth)
    // console.log(this.selectedYear);

    let reqBody = {
      dataId: this.selectedType?.code,
      yearId: this.selectedYear?.code,
      monthId: this.selectedMonth?.code,
      userId: this.userId,
      networkId: this.ipAddress,
      terminalId: this.ipAddress
    }

    if (this.selectedType?.code && this.selectedYear?.code && this.selectedMonth?.code) {
      // if(this.selectedType?.code != (null || undefined) && this.selectedYear?.code != (null || undefined) && this.selectedMonth?.code != (null || undefined)){
      if (this.selectedType?.code == 1) {
        this.getData('GetBeneficiaryToInsert', reqBody)
        // this.getBeneficiaryToInsert(reqBody);
      } else if (this.selectedType?.code == 2) {
        this.getData('GetBeneficiaryToInsertTransactionDetail', reqBody)
        // this.getBeneficiaryToInsertTransactionDetail(reqBody);
      } else if (this.selectedType?.code == 3) {
        this.getData('GetBeneficiaryCropDetail', reqBody)
        // this.getBeneficiaryGPSMasterData(reqBody);
      } else if (this.selectedType?.code == 4) {
        this.getData('GetBeneficiaryGeoFenceData', reqBody)
        // this.getBeneficiaryGeoFenceData(reqBody);
      } else if (this.selectedType?.code == 5) {
        this.getData('GetBeneficiaryGPSMasterData', reqBody)
        // this.getBeneficiaryCropDetail(reqBody);
      }
    }
  }

  clearFreezeOption(){
    this.freezeDataDropdown = false;
    this.showDataTable = false;
    this.dataToShow = [];
  }

  getData(api, reqBody) {
    this.loader.start();
    this.fApplicationService.getKrishiMapperData(api, reqBody)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.showDataTable = true;
          this.loader.close();
          if (res.length > 0) {
            this.freezeDataDropdown = true;
            this.dataToShow = res;
            this.columns = Object.keys(res[0]);
          } else {
            this.freezeDataDropdown = false;
            this.dataToShow = [];
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data not found',
            });
          }
        },
        error: (err) => {
          this.freezeDataDropdown = false;
          this.showDataTable = false;
          this.loader.close();
          this.dataToShow = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  // freezeDropdown(){
  //   this.freezeDataDropdown = true;
  // }

  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import('xlsx').then((xlsx) => {
      let dataToSave = modelData;
      // let dataToSave = modelData.map((d: any) => {
      //   return {
      //     'App User Type': d.AppUserType,
      //     'APP ID': d.appID,
      //     'Component Name': d?.CompName,
      //     'Farmer Name': d.farmerName,
      //     'Caste': d.Caste_Description,
      //     'Applicant Type': d.ApplicantType,
      //     'Next Level ID': d.NextLevelID,
      //     // 'Scheme Code': d.Scheme_Code,
      //     'Target Days': d.TargetDays,
      //     Block: d.block,
      //     District: d.district,
      //     'Registration Date': d.registerationDate,
      //     Remarks: d.remarks,
      //     Status: d.status,
      //     Village: d.village,
      //   };
      // });
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import('file-saver').then((FileSaver) => {
      let EXCEL_TYPE =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }

  onSubmitData(){

    let reqBody = {
      dataId: this.selectedType?.code,
      yearId: this.selectedYear?.code,
      monthId: this.selectedMonth?.code,
      userId: this.userId,
      networkId: this.ipAddress,
      terminalId: this.ipAddress
    }

    if (this.selectedType?.code && this.selectedYear?.code && this.selectedMonth?.code) {
      // if(this.selectedType?.code != (null || undefined) && this.selectedYear?.code != (null || undefined) && this.selectedMonth?.code != (null || undefined)){
      if (this.selectedType?.code == 1) {
        this.submitData('InsertBeneficiary', reqBody)
        // this.getBeneficiaryToInsert(reqBody);
      } else if (this.selectedType?.code == 2) {
        this.submitData('InsertBeneficiaryTransactionDetail', reqBody)
        // this.getBeneficiaryToInsertTransactionDetail(reqBody);
      } else if (this.selectedType?.code == 3) {
        this.submitData('InsertBeneficiaryCropDetail', reqBody)
        // this.getBeneficiaryGPSMasterData(reqBody);
      } else if (this.selectedType?.code == 4) {
        this.submitData('InsertBeneficiaryGeoFenceDetail', reqBody)
        // this.getBeneficiaryGeoFenceData(reqBody);
      } else if (this.selectedType?.code == 5) {
        this.submitData('InsertBeneficiaryGPSMasterDetail', reqBody)
        // this.getBeneficiaryCropDetail(reqBody);
      }
    }
  }

  submitData(api, reqBody) {
    this.loader.start();
    this.fApplicationService.postKrishiMapperData(api, reqBody)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          if(data == "Data insertion completed successfully."){
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: data,
            });
            this.clearFreezeOption();
          }else{
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: data,
            });
          }
          // this.showDataTable = true;
          // console.log(res);
          // if (res.length > 0) {
          //   this.freezeDataDropdown = true;
          //   this.dataToShow = res;
          //   this.columns = Object.keys(res[0]);
          //   console.log(this.columns);
          // } else {
          //   this.freezeDataDropdown = false;
          //   this.dataToShow = [];
          //   this.messageService.add({
          //     severity: 'info',
          //     summary: 'Info Message',
          //     detail: 'Data not found',
          //   });
          // }
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }
}
